import { Hint } from '~/hints/Hint';

import commandHint from './command';
import commandChannelMentionHint from './commandChannelMention';
import commandMentionHint from './commandMention';
import emojiHint from './emoji';
import mentionHint from './mention';

export const defaultEditorHints: Hint[] = [mentionHint, emojiHint];

export const editorHintsInThread: Hint[] = [commandHint, mentionHint, emojiHint];

export const editorHintsWithCommand: Hint[] = [
  commandMentionHint,
  commandChannelMentionHint,
  commandHint,
  mentionHint,
  emojiHint,
];

export const editorHintsWithCommandInPopup: Hint[] = [commandMentionHint, commandHint, mentionHint, emojiHint];
